export default {
  form: {
    first_name: {
      label: 'Etunimi',
    },
    last_name: {
      label: 'Sukunimi',
    },
    email: {
      label: 'Sähköposti',
    },
    phone_number: {
      label: 'Puhelinnumero',
    },
    birthday: {
      label: 'Syntymäpäivä',
    },
    city: {
      label: 'Kaupunki',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    success: 'Profiili päivitetty onnistuneesti',
    error: 'Profiilin päivittäminen epäonnistui',
  },
};
